//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      formLayout: 'horizontal',
      user_tel: '',
      code: '',
      sendShow: true,
      timers: 0
    }
  },
  created() {},
  computed: {
    formItemLayout() {
      const { formLayout } = this
      if (formLayout === 'horizontal') {
        return {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 }
        }
      } else {
        return {}
      }
    },
    buttonItemLayout() {
      const { formLayout } = this
      if (formLayout === 'horizontal') {
        return { wrapperCol: { span: 14, offset: 4 } }
      } else {
        return {}
      }
    }
  },
  methods: {
    sendCode() {
        this.timers = 60
        let that = this
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (!myreg.test(this.user_tel)) {
            this.$toast('请检查手机号码')
            return false
        } else {
            this.sendShow = false
            let param = {
                phone: this.user_tel
            }
            this.$http
                .post(global.HTTPMobile + '/delivery/send/sms', param)
                .then(function (resp) {
                    if (resp.data.code === 0) {
                        that.sendShow = false
                        that.timers = 60
                        let t = setInterval(function () {
                            that.timers = --that.timers
                            if (that.timers === 0) {
                                that.timers = 0
                                clearInterval(t)
                                that.sendShow = true
                            }
                        }, 1000)
                    } else {
                        that.sendShow = true
                        that.$toast(resp.data.msg)
                    }
                })
                .catch(function (err) {
                    console.log(err)
                })
        }
    },
    loginSubmit() {
        console.log(this.phone)
        if (this.loginType !== 0) {
            if (!this.phone) {
                this.$toast('手机号不能为空')
                return false
            }
            if (this.loginType === 1) {
                if (!this.pass) {
                    this.$toast('密码不能为空')
                    return false
                }
            } else if (this.loginType === 2) {
                if (!this.code) {
                    this.$toast('验证码不能为空')
                    return false
                }
            }
        }
        let that = this
        let param = {
            user_tel: this.phone,
            code: this.code,
            password: this.pass,
            loginType: 2,
            auto: this.checkBox === true ? 1 : 0
        }
        this.$http
            .post(global.HTTP + 'login/login', param)
            .then(function (resp) {
                if (resp.data.code === 0) {
                    let day = 1
                    if (that.selectBox === true) day = 3
                    sessionStorage.setItem('token', resp.data.data.token)
                    sessionStorage.setItem('gtoken', resp.data.data.gtoken)
                    sessionStorage.setItem('phone', that.phone)

                    global.ratio = resp.data.data.ratio ? resp.data.data.ratio : 1
                    console.log(resp.data.data.ratio, 9999)
                    sessionStorage.setItem('ratio', global.ratio)

                    sessionStorage.setItem('tourist', resp.data.data.tourist)

                    that.$role.saveCookies(resp.data.data.user, day)
                    that.$role.saveGlobal(resp.data.data.user)
                    
                    let menus = resp.data.data.menus

                    let hideUrl = {
                        component: "none",
                        icon: null,
                        id: 999,
                        is_hidden: 1,
                        is_leaf: 0,
                        menu_id: 15,
                        name: "区域共享门店业绩",
                        path: "/shareOrders"
                    }

                    menus.forEach(item => {
                        if (item.id == 15 && ( resp.data.data.user.id == 108 || resp.data.data.user.id == 52 || resp.data.data.user.id == 115)) {
                            item.children.push(hideUrl)
                        }
                    });

                    that.$role.setRoleMenu(menus)
                    that.$role.orderSource()
                    that.$role.sellerList()
                    that.$role.agentList()
                    that.$role.regionList()
                    that.$role.agentLevel()
                    that.$role.orderDelivery()
                    if (!resp.data.data.user.password) that.$router.push('setPass')
                    else that.$router.push('index')
                } else {
                    that.$toast(resp.data.msg)
                }
            })
            .catch(function (err) {
                console.log(err)
            })
    },
    submitForm() {
      if (!this.user_tel) {
        this.$toast('手机号不能为空')
        return false
      }
      if (!this.code) {
        this.$toast('验证码不能为空')
        return false
      }
      let that = this
      let param = {
          user_tel: this.user_tel,
          code: this.code,
          // password: this.pass,
          loginType: 2,
          // auto: this.checkBox === true ? 1 : 0
      }
      this.$http
          .post(global.HTTP + 'login/login', param)
          .then(function (resp) {
              if (resp.data.code === 0) {
                let day = 1
                if (that.selectBox === true) day = 3
                sessionStorage.setItem('token', resp.data.data.token)
                sessionStorage.setItem('gtoken', resp.data.data.gtoken)
                sessionStorage.setItem('phone', that.phone)

                global.ratio = resp.data.data.ratio ? resp.data.data.ratio : 1
                console.log(resp.data.data.ratio, 9999)
                sessionStorage.setItem('ratio', global.ratio)

                sessionStorage.setItem('tourist', resp.data.data.tourist)

                that.$role.saveCookies(resp.data.data.user, day)
                that.$role.saveGlobal(resp.data.data.user)
                // 账号存在，绑定手机号
                that.bindPhone()
              } else {
                  that.$toast(resp.data.msg)
              }
          })
          .catch(function (err) {
              console.log(err)
          })
    },
    bindPhone () {
      let that = this
      let param = {
        user_tel: this.user_tel,
        unionid: this.$route.query.unionid
      }
      this.$http
        .post(global.HTTP + 'login/bdPhone', param)
        .then(function(resp) {
          if (resp.data.code === 0) {
            that.$message.success('手机号绑定成功', 1)
            that.$role.saveCookies(resp.data.data.user, 1)
            that.$role.saveGlobal(resp.data.data.user)
            that.$role.setRoleMenu(resp.data.data.menus)
            that.$role.orderSource()
            that.$role.sellerList()
            that.$role.agentList()
            that.$role.regionList()
            that.$role.agentLevel()
            that.$role.orderDelivery()
            if (!resp.data.data.user.password) that.$router.push('setPass')
            else that.$router.push('index')
          } else {
            that.$toast(resp.data.msg)
          }
        })
        .catch(function(err) {
          console.log(err)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/login/bdPhone.vue